import type { Action } from 'redux';
import { ErrorProvider } from '../../../../../libraries/branch-tooling-next/Error/ErrorProvider';
import NotificationActions from '../../../../main/actions/NotificationActions';
import type { AdPartner, AdPartnerWithOnlyDataForSKAN } from '../../../../main/types/adPartnerTypes';
import type { Dispatch } from '../../../types/redux.types';
import { saveAdPartner } from '../../AdPartner/actions';
import {
  UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR,
  UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING,
  UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS,
} from '../SKAdNetwork.constants';
import { getSKANAdPartners } from './getSKANAdPartners.action';

const errorProvider = new ErrorProvider();

export function updateAdPartnersForSKANAgencyPermissions(updatedAdPartners: (AdPartner | AdPartnerWithOnlyDataForSKAN)[]) {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING,
    });

    try {
      await Promise.all(
        updatedAdPartners.map(async (adPartner) => {
          return dispatch(
            saveAdPartner({
              partner: adPartner,
              options: {
                withNotification: false,
              },
            })
          );
        })
      );

      dispatch({
        type: UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS,
      });

      dispatch(getSKANAdPartners());

      NotificationActions.showNotification('Successfully updated agency permissions', 'success');
    } catch (err) {
      dispatch({
        type: UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR,
      });

      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
}

export type UpdateAdPartnersForSKANAgencyPermissionsLoadingAction = Action<
  typeof UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_LOADING
>;

export type UpdateAdPartnersForSKANAgencyPermissionsSuccessAction = Action<
  typeof UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_SUCCESS
>;

export type UpdateAdPartnersForSKANAgencyPermissionsErrorAction = Action<
  typeof UPDATE_AD_PARTNERS_FOR_SKAN_AGENCY_PERMISSIONS_ERROR
>;
